module.exports = __webpack_public_path__ + "img/home-preview-kr.285efd13.png";